<script>
import patientApi from '../../api/patient/index.js';
import selectedPatient from '../../store/selectedPatient';
import MainLayout from '@/layouts/MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import Chevron from '@/components/shared/Chevron';

export default {
  name: 'MyPatientsList',
  components: {
    MainLayout,
    GridRow,
    GridCol,
    Chevron
  },
  data() {
    return {
      patients: [],
      loading: false,
      error: null
    };
  },
  created() {
    this.fetchPatients();
  },
  computed: {
    getBreadcrumb() {
      return [
        { link: '/workspace', name: this.$t('menu.workspace') },
        { link: '/my-patients', name: this.$t('health.my-patients.title'), disabled: true }
      ];
    }
  },
  methods: {
    fetchPatients() {
      this.loading = true;
      this.error = null;

      patientApi.getMyPatients(this)
        .then((data) => {
          this.patients = data;
          this.loading = false;
        })
        .catch((error) => {
          console.error('Error fetching patients:', error);
          this.error = 'health.my-patients.error';
          this.loading = false;
        });
    },
    viewAnalytics(patientId) {
      selectedPatient.set(patientId);
      this.$router.push({ path: '/analytics/list' });
    }
  }
};
</script>

<template>
  <main-layout controlsBg="light" :hasControlsBar="false" :breadcrumb="getBreadcrumb">
    <div class="container">
      <grid-row class="margin-top-xl" column-align="center">
        <grid-col col-size="10">
          <div id="header">
            <h1 class="header-title">
              <chevron @click="$router.push({name: 'Workspace'})"/>
              {{ $t('health.my-patients.title') }}
            </h1>
          </div>
        </grid-col>
      </grid-row>

      <grid-row class="margin-top-xl" column-align="center">
        <grid-col col-size="10">
          <div class="patients-list">

            <div class="loading" v-if="loading">
              {{ $t('health.my-patients.loading') }}
            </div>

            <div class="error" v-if="error">
              <p>{{ $t(error) }}</p>
              <button @click="fetchPatients" class="btn-retry">{{ $t('health.my-patients.retry') }}</button>
            </div>

            <table class="patients-table" v-if="!loading && !error && patients.length > 0">
              <thead>
              <tr>
                <th>{{ $t('health.my-patients.table.id') }}</th>
                <th>{{ $t('health.my-patients.table.username') }}</th>
                <th>{{ $t('health.my-patients.table.name') }}</th>
                <th>{{ $t('health.my-patients.table.surname') }}</th>
                <th>{{ $t('health.my-patients.table.email') }}</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="patient in patients" :key="patient.id" @click="viewAnalytics(patient.id)" class="clickable-row">
                <td class="bold-text">{{ patient.id }}</td>
                <td>{{ patient.username }}</td>
                <td>{{ patient.name || '-' }}</td>
                <td>{{ patient.surnames || '-' }}</td>
                <td class="email-text">{{ patient.email }}</td>
                <td class="icon-cell"><chevron right /></td>
              </tr>
              </tbody>
            </table>

            <div class="no-data" v-if="!loading && !error && patients.length === 0">
              {{ $t('health.my-patients.empty') }}
            </div>

          </div>
        </grid-col>
      </grid-row>
    </div>
  </main-layout>
</template>

<style scoped lang="scss">
.patients-list {
  background: #ffffff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.patients-table {
  width: 100%;
  border-collapse: collapse;

  th, td {
    padding: 15px;
    text-align: left;
    border-bottom: 1px solid #f0f0f0;
  }

  th {
    background-color: #fafafa;
    color: #555;
    font-weight: bold;
  }

  .clickable-row {
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: #f9f9f9;
    }
  }

  .bold-text {
    font-weight: 600;
    color: #1976d2;
  }

  .email-text {
    color: #0066cc;
  }

  .icon-cell {
    text-align: right;
    color: #888;
    width: 40px;
  }
}

.loading, .no-data {
  text-align: center;
  padding: 40px 20px;
  color: #888;
}

.error {
  text-align: center;
  background-color: #ffebee;
  border: 1px solid #ef5350;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;

  p {
    margin: 0 0 12px 0;
    color: #c62828;
    font-size: 14px;
  }

  .btn-retry {
    background-color: #ef5350;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;

    &:hover {
      background-color: #e53935;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/patient/MyPatientsList.vue